<template>
  <header
    :class="{
      'desktop': !isMobile,
      'mobile': isMobile,
      'home': isHome,
      'landing': isLanding,
      'homeout': !isHome && !isLanding,
    }">
    <navbar-mobile v-if="isMobile" />
    <navbar-desktop v-else />
  </header>
</template>

<script>

const NavbarMobile = () => import(/* webpackChunkName: "navbarmobile" */ './Mobile');
const NavbarDesktop = () => import(/* webpackChunkName: "navbardesktop" */ './Desktop');

export default {
  name: 'Header',
  data() {
    return {
      landings: [
        'aboutus', 'joinus', 'website',
      ],
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isHome() {
      return this.$route.name === 'home';
    },
    isLanding() {
      return this.landings.some((p) => p === this.$route.name);
    },
  },
  components: {
    NavbarMobile,
    NavbarDesktop,
  },
};
</script>

<style lang="scss">

header {
  width: 100%;
  background: white;

  // to allow tooltips change contain: layout to contain: inherit
  .v-toolbar {
    contain: inherit!important; // to allow tooltips
    transform: none!important;
  }

  .v-toolbar__content {
    padding-left: 0;
    padding-right: 0;
    position: static; // to allow tooltips
  }

  a {
    color: black!important;
  }

  &.home {
    background: transparent;
    a {
      color: white!important;
    }
  }
}

</style>
